import React from 'react'

const SuccessfullCertificados = () => {
    return (
        <div>SuccessfullCertificados</div>
    )
}

export default SuccessfullCertificados